import { convertNumberToFractionalMoneyString } from './utils'

export const getDifference = (totalSum: number, paymentAmount: string) => {
  const sum = Number(convertNumberToFractionalMoneyString(totalSum))

  return Number(paymentAmount) > sum ? Number(paymentAmount) - sum : null
}
